import { useEffect } from 'react';

/** Set `<title>` to "`title` | Resham Tales" while mounted, restoring the previous title afterwards. */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} | Resham Tales`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
